"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconSolarAndWind = function IconSolarAndWind(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m35.394 4.466-2-2-.708.708 2 2zm.53.432 1.272 1.544a3 3 0 1 0 3.995 4.47l.137-.142 1.484 1.34a5 5 0 1 1-7.064-7.06zm-21.867 7.927a3.28 3.28 0 0 0-4.117-.561l-.427.278-.167.102a2.28 2.28 0 0 1-2.7-.335l-.692.722.153.138a3.28 3.28 0 0 0 3.937.22l.353-.231.167-.102a2.28 2.28 0 0 1 2.85.552l.772-.636zm0 3.71a3.28 3.28 0 0 0-4.117-.562l-.427.28-.167.1a2.28 2.28 0 0 1-2.7-.335l-.692.723.153.138a3.28 3.28 0 0 0 3.937.22l.353-.231.167-.102a2.28 2.28 0 0 1 2.85.552l.772-.636zM40 18.97v-4h-1v4zm-7-11v1h-4v-1zm2.394 5.204-.708-.708-2 2 .708.708zm8-.708 2 2-.708.708-2-2zm-19.3 16.943h-.188l-.838 12.561h1.863zm-3.86-1.698a5 5 0 0 1-1.03-1.85l-7.754 5.885zm-1.15-4.271c.248-1.26.97-2.35 1.971-3.078l1.198-12.906a1.74 1.74 0 0 1 1.717-1.455c.8 0 1.491.545 1.693 1.365l.032.157 1.249 12.853a5 5 0 0 1 1.949 3.048l10.724 8.199a1.74 1.74 0 0 1 .435 2.236c-.406.706-1.242 1.03-2.05.782l-.152-.054-11.77-5.448.989 14.831H20.93l.989-14.833-11.87 5.452A1.74 1.74 0 0 1 8.22 31.7l.124-.107zm9.694 2.414 7.729 5.909-8.758-4.055c.465-.53.82-1.16 1.03-1.854m-5.633-6.373.832-8.98.871 8.982a5 5 0 0 0-1.703-.002m-.655 4.929a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m2 0a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0m-.5-3a3 3 0 1 1 0 6 3 3 0 0 1 0-6",
    clipRule: "evenodd"
  })));
};

export { IconSolarAndWind, IconSolarAndWind as default };
